<app-leveltwo [pageName]="'Data Sales'">
<div class="General">
  <h3>{{'GISsales.SearchTitle'|translate}}</h3>
  <h4>{{'GISsales.GISTax'|translate}}</h4>
  <p>{{'GISsales.SearchDescription'|translate}}</p>
  <p>{{'GISsales.ThisGIS'|translate}}</p>
  <p>{{'GISsales.Variousrecorded'|translate}}</p>
  <p>{{'GISsales.Onebase'|translate}}</p>

  <h5>{{'GISsales.Onebase'|translate}}</h5>
  <ul>
    <li>{{'GISsales.Registeredtostate'|translate}}</li>
    <li>{{'GISsales.Createdusing'|translate}}</li>
    <li>{{'GISsales.Canbeused'|translate}}</li>
  </ul>



  <h5>{{'GISsales.Topurchase'|translate}}</h5>
  <strong>{{'GISsales.PropertyDataSales'|translate}}</strong><br>
  {{'DataSales.Phone'|translate}} | <b>(213) 974-3363</b><br>
  {{'DataSales.Days'|translate}} | {{'DataSales.Monday'|translate}}<br>
  {{'DataSales.Hours'|translate}} | 7:30 am - 5:00 pm PST<br>
  {{'DataSales.Email'|translate}} | <a href="mailto:datasales@assessor.lacounty.gov">datasales&#64;assessor.lacounty.gov</a><br><br>

  <p [innerHTML]="'GISsales.Fortechnical'|translate"></p>
  <p [innerHTML]="'GISsales.Pleaseremember'|translate"></p>

</div>
</app-leveltwo>
